export default Object.freeze({
  FormField: 'form-field',
  Variable: 'variable',
  Formula: 'formula',
  FixedValue: 'fixed-value',
  InternalField: 'internal-field',
  IterationStepData: 'iteration-step-data',
  GeneratedDocument: 'generated-document',
});
